module.exports = __webpack_public_path__ + "img/vclounge.c4df0b2e.png";